module.exports = __webpack_public_path__ + "img/pager2-quick-icon8.8fa76831.png";